"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Drawer = _interopRequireDefault(require("@mui/material/Drawer"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _components = require("./components");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Sidebar = _ref => {
  let {
    pages,
    open,
    variant,
    onClose,
    anchor = "left"
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Drawer.default, {
    anchor: anchor,
    onClose: () => onClose(),
    open: open,
    variant: variant,
    sx: {
      '& .MuiPaper-root': {
        width: '100%',
        maxWidth: 280
      }
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      sx: {
        height: '100%',
        padding: 1
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SidebarNav, {
        pages: pages
      })
    })
  });
};
Sidebar.propTypes = {
  onClose: _propTypes.default.func,
  open: _propTypes.default.bool.isRequired,
  variant: _propTypes.default.string.isRequired
};
var _default = exports.default = Sidebar;